<p class="mat-body-medium"><ng-content /></p>
